<template>
	<div class="row justify-content-center">
		<div class="col-md-5">
			<h3 class="text-center">Crea CARD</h3>
			<form @submit.prevent="onFormSubmit">
				<div class="form-group">
					<label>CARD ID</label>
					<input type="text" class="form-control" v-model="card.key" required>
				</div>

				<div class="form-group">
					<label>Cognome Nome</label>
					<input type="text" class="form-control" v-model="card.data.fullName" required>
				</div>

				<div class="form-group">
					<label>Nome Display</label>
					<input type="text" class="form-control" v-model="card.data.displayName" required>
				</div>

				<div class="form-group">
					<label>Ruolo</label>
					<select type="number" class="form-control" v-model="card.data.role"
					required>
						<option value=1>Store Mgr</option>
						<option value=2>Noleggio</option>
						<option value=3>Cliente</option>
					</select>
				</div>

				<div class="form-group">
					<input type="checkbox" class="form-control" v-model="card.data.active" required>
					<label>Attiva / disattiva CARD</label>
				</div>

				<div class="form-group">
					<button class="btn btn-primary btn-block">Crea CARD</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { db } from '../../firebase/config.js';

	export default {
		data() {
			return {
				card: {
					key: '',
					data: {
						fullName: '',
						displayName: '',
						role: 3,
						active: true
					}
				}
			}
		},
		methods: {
			onFormSubmit(event) {
				event.preventDefault()
				db.collection('cards').doc(this.card.key).set(this.card.data).then(() => {
					alert("CARD creata!");
					this.card.key = ''
					this.card.data.fullName = ''
					this.card.data.displayName = ''
					//this.card.data.role = '3'
					//this.card.data.active = true
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	};
</script>
<style>
	.btn-primary {
		background: #bad300;
		border: #bad000;
	}
	.material-icons {
		font-size: 24px;
		margin-right: 10px;
		color: #ccc;
		cursor: pointer;
	}
	.material-icons:hover {
		color: #777;
	}
</style>